"use client"
import { Home, User, Video, Bell, Settings, ChevronDown } from "lucide-react"

const menuItems = [
  { id: "home", icon: Home, label: "Home", badge: null },
  { id: "profile", icon: User, label: "Profile", badge: null },
  { id: "meetings", icon: Video, label: "Meetings", badge: { count: 3, type: "blue" } },
  { id: "notifications", icon: Bell, label: "Notifications", badge: { count: 12, type: "red" } },
  { id: "settings", icon: Settings, label: "Settings", badge: null },
]

export function Sidebar({ isOpen, currentPage, onNavigate, onClose }) {
  return (
    <aside className={`sidebar ${!isOpen ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        <div className="logo">UneeCall</div>

        <div className="profile-section">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNsJJ6y7jSi0ATS9DgFA7tKuE_z-jjbeRDOg&s"
            alt="Profile"
            className="profile-avatar"
          />
          <div className="profile-info">
            <h3>Gaurav Gambhir</h3>
            <div className="status-badge">
              <div className="status-dot"></div>
              <span>Online</span>
              <ChevronDown size={12} />
            </div>
          </div>
        </div>
      </div>

      <div className="sidebar-content">
        <nav className="menu-section">
          <div className="menu-label">Menu</div>
          <ul className="menu-items">
            {menuItems.map((item) => (
              <li key={item.id} className="menu-item">
                <button
                  className={`menu-link ${currentPage === item.id ? "active" : ""}`}
                  onClick={() => {
                    onNavigate(item.id)
                    // Close sidebar on mobile after navigation
                    if (window.innerWidth <= 768) {
                      onClose()
                    }
                  }}
                >
                  <item.icon className="menu-icon" />
                  <span>{item.label}</span>
                  {item.badge && <span className={`menu-badge ${item.badge.type}`}>{item.badge.count}</span>}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </aside>
  )
}
